import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../config/config";

export const useSession = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const token = localStorage.getItem('X-JustRPC-Token');
        if (!token) throw new Error('No token');
        const { data } = await axios.get(`${API_URL}/session`, {
          headers: { 'X-JustRPC-Token': token },
        });
        if (data.isGuest) throw new Error('Guest');
        setUser(data.user);
        setIsAuthenticated(true);
      } catch (e) {
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  return { loading, isAuthenticated, user };
};
